<template>
  <div class="image-preview">
    <img :src="imageSrc" :alt="imageAlt" class="image-preview__image" />
  </div>
</template>

<script>
export default {
  name: 'AppImagePreview',
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      default: 'Preview image'
    }
  }
}
</script>

<style scoped lang="scss">
.image-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 90vw;
  max-height: 90vh;

  &__image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }
}
</style>
